const environment = {
  production: {
    apiPath: process.env.APIPATH || 'https://www.takemetour.com/api',
    mediaPath: 'https://d1j7gws94ta18j.cloudfront.net',
    nonWebPMediaPath: 'https://d1j7gws94ta18j.cloudfront.net',
    webPath: {
      en: 'https://www.takemetour.com',
      th: 'https://pachantiew.takemetour.com',
      zh: 'https://zh.takemetour.com',
    },
    // assetPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0',
    assetPath: 'https://d2d3n9ufwugv3m.cloudfront.net',
    pdfPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0',
    uiKitAssetPath: 'https://ddhiorx9qbcay.cloudfront.net',
    s3Bucket: 'takemetour-3-0',
  },
  staging: {
    apiPath: process.env.APIPATH || 'https://staging.takemetour.com/api',
    uiKitAssetPath: 'https://takemetour-uikit-asset-dev.storage.googleapis.com',
  }
}[process.env.REACT_APP_ENV || 'development'];

// Use relative path in development to leverage proxy, full URL in staging/production
const isDevelopment = !process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development';

module.exports = Object.assign({
  apiPath: process.env.APIPATH || (isDevelopment ? '/api' : 'https://staging.takemetour.com/api'),
  pdfPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-dev',
  mediaPath: 'https://d3uplctqj7yzf0.cloudfront.net',
  uiKitAssetPath: 'https://takemetour-uikit-asset-dev.storage.googleapis.com',
  // nonWebPMediaPath: 'https://d17572qoeejomw.cloudfront.net',
  nonWebPMediaPath: 'https://d3uplctqj7yzf0.cloudfront.net',
  webPath: {
    en: 'https://staging.takemetour.com',
    th: 'https://pachantiew.staging.takemetour.com',
    zh: 'https://zh.staging.takemetour.com',
  },
  assetPath: 'https://dja3e86j343dh.cloudfront.net',
  s3Bucket: 'takemetour-3-0-dev',
}, environment);



// WEBPACK FOOTER //
// ./src/config.js